
export const sequences2031 = [
  ['are', 'rate', 'trace', 'cartel'],
  ['ear', 'rage', 'sarge', 'greasy'],
  ['eat', 'rate', 'extra', 'baxter'],
  ['ate', 'east', 'beast', 'breast'],
  ['tea', 'late', 'alter', 'learnt'],
  ['are', 'hear', 'harem', 'hammer'],
  ['ear', 'hear', 'rehab', 'breath'],
  ['eat', 'rate', 'crate', 'carpet'],
  ['ate', 'seat', 'tesla', 'stable'],
  ['tea', 'gate', 'great', 'target'],
  ['are', 'race', 'raced', 'traced'],
  ['ear', 'read', 'aired', 'diaper'],
  ['eat', 'late', 'latte', 'talent'],
  ['ate', 'rate', 'react', 'crater'],
  ['tea', 'heat', 'heath', 'health'],
  ['are', 'rage', 'barge', 'beggar'],
  ['ear', 'tear', 'eater', 'easter'],
  ['eat', 'seat', 'slate', 'stella'],
  ['ate', 'heat', 'teach', 'chaste'],
  ['tea', 'tear', 'after', 'fatter'],
  ['are', 'dear', 'rated', 'thread'],
  ['ear', 'near', 'learn', 'learnt'],
  ['eat', 'team', 'meant', 'mental'],
  ['ate', 'late', 'latte', 'talent'],
  ['tea', 'late', 'tesla', 'stella'],
  ['are', 'dare', 'dream', 'dreamt'],
  ['ear', 'dear', 'rated', 'thread'],
  ['eat', 'tale', 'dealt', 'talked'],
  ['ate', 'fate', 'fated', 'farted'],
  ['tea', 'tale', 'table', 'battle'],
  ['are', 'bare', 'zebra', 'blazer'],
  ['ear', 'earl', 'realm', 'palmer'],
  ['eat', 'late', 'steal', 'latest'],
  ['ate', 'tale', 'slate', 'stable'],
  ['tea', 'take', 'stake', 'basket'],
  ['are', 'bare', 'amber', 'marble'],
  ['ear', 'tear', 'tread', 'thread'],
  ['eat', 'tear', 'rated', 'thread'],
  ['ate', 'late', 'tesla', 'stella'],
  ['tea', 'heat', 'earth', 'rather'],
  ['are', 'rate', 'tread', 'dreamt'],
  ['ear', 'bear', 'rehab', 'breath'],
  ['eat', 'east', 'haste', 'hasten'],
  ['ate', 'tear', 'alter', 'taller'],
  ['tea', 'rate', 'heart', 'rather'],
  ['are', 'tear', 'react', 'racket'],
  ['ear', 'race', 'clear', 'recall'],
  ['eat', 'rate', 'trade', 'dreamt'],
  ['ate', 'beat', 'table', 'battle'],  // Replaced 'albert' with 'bottle'
  ['tea', 'tale', 'metal', 'mental'],
  ['are', 'earl', 'clear', 'cellar'],
  ['ear', 'rate', 'great', 'target'],
  ['eat', 'take', 'skate', 'casket'],
  ['ate', 'seat', 'beast', 'basket'],
  ['tea', 'rate', 'eater', 'repeat'],
  ['are', 'real', 'alert', 'travel'],  // Replaced 'albert' with 'travel'
  ['ear', 'earl', 'relay', 'nearly'],
  ['eat', 'tale', 'latte', 'talent'],
  ['ate', 'rate', 'eater', 'repeat'],
  ['tea', 'east', 'beast', 'breast'],
  ['are', 'dare', 'cared', 'carved'],
  ['ear', 'care', 'clear', 'recall'],
  ['eat', 'seat', 'steak', 'casket'],
  ['ate', 'tear', 'trace', 'crater'],
  ['tea', 'tape', 'plate', 'palate'],
  ['are', 'dare', 'beard', 'barged'],
  ['ear', 'read', 'grade', 'agreed'],
  ['eat', 'rate', 'stare', 'breast'],
  ['ate', 'take', 'taken', 'tanker'],
  ['tea', 'mate', 'metal', 'amulet'],
  ['are', 'dear', 'trade', 'hatred'],
  ['ear', 'dear', 'trade', 'hatred'],
  ['eat', 'east', 'steal', 'stella'],
  ['ate', 'date', 'trade', 'hatred'],
  ['tea', 'tear', 'heart', 'breath'],
  ['art', 'star', 'smart', 'master'],
  ['use', 'sure', 'super', 'supper'],
  ['rid', 'ride', 'drive', 'driver'],
  ['ran', 'barn', 'brand', 'brandy'],
  ['aid', 'dial', 'ideal', 'nailed'],
  ['rat', 'tear', 'cater', 'carpet'],
  ['art', 'rate', 'earth', 'breath'],
  ['red', 'dear', 'heard', 'harder'],
  ['ole', 'hole', 'hello', 'holler'],
  ['ale', 'meal', 'metal', 'hamlet'],
  ['eat', 'date', 'tread', 'dreamt'],
  ['lad', 'deal', 'laced', 'called'],
  ['pat', 'tape', 'paste', 'staple'],
  ['one', 'gone', 'goner', 'longer'],
  ['get', 'gate', 'agent', 'eating'],
  ['sea', 'sake', 'asked', 'soaked'],
  ['rat', 'tear', 'rated', 'traced'],
  ['set', 'seat', 'tesla', 'salute'],
  ['red', 'ride', 'aired', 'admire'],
  ['car', 'care', 'reach', 'charge'],
  ['cap', 'pace', 'place', 'palace'],
  ['ran', 'darn', 'drawn', 'warden'],
  ['age', 'rage', 'anger', 'german'],
  ['red', 'read', 'tread', 'hatred'],
  ['rid', 'ride', 'dried', 'riddle'],
  ['mad', 'made', 'medal', 'blamed'],
  ['met', 'team', 'mater', 'matter'],
  ['led', 'lied', 'slide', 'shield'],
  ['nut', 'turn', 'burnt', 'burton'],
  ['rid', 'ride', 'riled', 'ridley'],
  ['dog', 'gold', 'lodge', 'golden'],
  ['bro', 'bore', 'boner', 'bronze'],
  ['ace', 'each', 'beach', 'breach'],
  ['sea', 'base', 'saber', 'rabies'],
  ['don', 'bond', 'blond', 'blonde'],
  ['lay', 'ally', 'sally', 'lastly'],
  ['net', 'rent', 'entry', 'trendy'],
  ['rip', 'trip', 'strip', 'spirit'],
  ['sea', 'seat', 'steak', 'streak'],
  ['rat', 'rate', 'react', 'crater'],
  ['car', 'care', 'trace', 'cartel'],
  ['red', 'reed', 'creed', 'decker'],
  ['lad', 'dial', 'tidal', 'tailed'],
  ['ten', 'sent', 'stone', 'honest'],
  ['set', 'east', 'skate', 'casket'],
  ['nor', 'worn', 'wrong', 'rowing'],
  ['red', 'ride', 'rider', 'raider'],
  ['lad', 'dale', 'delta', 'lasted'],
  ['hat', 'chat', 'cheat', 'chaste'],
  ['don', 'done', 'demon', 'modern'],
  ['art', 'tear', 'rated', 'traced'],
  ['set', 'east', 'steam', 'stream'],
  ['led', 'dale', 'medal', 'mailed'],
  ['lay', 'ally', 'alley', 'really'],
  ['ran', 'rang', 'range', 'orange'],
  ['sea', 'east', 'tesla', 'stella'],
  ['rid', 'ride', 'tired', 'direct'],
  ['lit', 'lift', 'flirt', 'filter'],
  ['met', 'term', 'metro', 'mother'],
  ['red', 'dear', 'tread', 'dreamt'],
  ['rat', 'tear', 'alter', 'taller'],
  ['top', 'port', 'troop', 'pronto'],
  ['sea', 'seal', 'least', 'stella'],
  ['act', 'fact', 'craft', 'factor'],
  ['ale', 'meal', 'camel', 'malice'],
  ['let', 'belt', 'table', 'tablet'],  // Replaced 'albert' with 'tablet'
  ['ask', 'sake', 'snake', 'sneaky'],
  ['ain', 'rain', 'grain', 'racing'],
  ['age', 'gear', 'anger', 'garden'],
  ['air', 'rain', 'drain', 'daring'],
  ['son', 'soon', 'snoop', 'snoopy'],
  ['ace', 'care', 'react', 'crater'],
  ['tie', 'item', 'merit', 'mister'],
  ['sat', 'east', 'steam', 'stream'],
  ['sit', 'site', 'exist', 'sexist'],
  ['con', 'once', 'canoe', 'deacon'],
  ['won', 'down', 'owned', 'wonder'],
  ['hut', 'thou', 'ought', 'bought'],
  ['set', 'sent', 'tense', 'senate'],
  ['sat', 'east', 'yeast', 'safety'],
  ['bat', 'boat', 'baton', 'obtain'],
  ['rob', 'bore', 'boner', 'bronze'],
  ['rid', 'ride', 'hired', 'hinder'],
  ['red', 'dear', 'dream', 'admire'],
  ['age', 'gear', 'grate', 'target'],
  ['sea', 'seal', 'leash', 'hassle'],
  ['ray', 'yard', 'randy', 'brandy'],
  ['ain', 'rain', 'brain', 'binary'],
  ['ice', 'nice', 'nicer', 'prince'],
  ['row', 'word', 'crowd', 'coward'],
  ['had', 'hard', 'heard', 'shared'],
  ['hat', 'heat', 'wheat', 'wreath'],
  ['set', 'seat', 'taste', 'estate'],
  ['bar', 'barn', 'urban', 'turban'],
  ['she', 'shed', 'shred', 'rushed'],
  ['sea', 'seat', 'stage', 'staged'],
  ['lit', 'tail', 'trail', 'tribal'],
  ['cat', 'coat', 'coast', 'mascot'],
  ['rat', 'tear', 'heart', 'father'],
  ['lad', 'deal', 'delay', 'played'],
  ['set', 'step', 'slept', 'staple'],
  ['pro', 'rope', 'power', 'powder'],
  ['age', 'rage', 'large', 'gravel'],
  ['ace', 'case', 'scale', 'castle'],
  ['led', 'lied', 'glide', 'girdle'],
  ['ran', 'warn', 'rowan', 'narrow'],
  ['bee', 'beer', 'breed', 'bender'],
  ['for', 'fort', 'forty', 'frosty'],
  ['lad', 'lead', 'dealt', 'lasted'],
  ['pal', 'pale', 'place', 'palace'],
  ['end', 'lend', 'blend', 'blonde'],
  ['row', 'worn', 'owner', 'downer'],
  ['sun', 'sung', 'using', 'genius'],
  ['car', 'care', 'cream', 'camera'],
  ['top', 'stop', 'spout', 'sprout'],
  ['sue', 'sure', 'serum', 'summer'],
  ['red', 'dare', 'raced', 'scared'],
  ['rat', 'star', 'smart', 'master'],
  ['let', 'tale', 'tesla', 'salute'],
  ['end', 'tend', 'trend', 'tender'],
  ['sue', 'sure', 'curse', 'course'],
  ['top', 'plot', 'pilot', 'polite'],
  ['red', 'drew', 'wired', 'weirdo'],
  ['age', 'gear', 'grave', 'garvey'],
  ['bro', 'born', 'borne', 'bronze'],
  ['hid', 'hide', 'hired', 'hinder'],
  ['rat', 'rate', 'mater', 'market'],
  ['set', 'east', 'stake', 'basket'],
  ['per', 'pure', 'purse', 'pursue'],
  ['bro', 'born', 'baron', 'carbon'],
  ['her', 'hire', 'their', 'either'],
  ['sea', 'sale', 'stale', 'slater'],
  ['nap', 'plan', 'plane', 'planet'],
  ['air', 'liar', 'april', 'pillar'],
  ['led', 'lead', 'delta', 'talked'],
  ['rat', 'part', 'strap', 'pastor'],
  ['the', 'them', 'theme', 'helmet'],
  ['get', 'gate', 'great', 'target'],
  ['ray', 'gray', 'gravy', 'garvey'],
  ['our', 'tour', 'tumor', 'tumour'],
  ['lap', 'pale', 'pedal', 'placed'],
  ['boo', 'boot', 'boost', 'boston'],
  ['lee', 'else', 'sleep', 'please'],
  ['met', 'mate', 'steam', 'stream'],
  ['sec', 'case', 'sauce', 'accuse'],
  ['fat', 'fate', 'after', 'father'],
  ['lad', 'laid', 'tidal', 'detail'],
  ['ice', 'eric', 'cried', 'credit'],
  ['net', 'note', 'stone', 'stolen'],
  ['red', 'rude', 'urged', 'grudge'],
  ['ain', 'rain', 'rainy', 'brainy'],
  ['rat', 'star', 'stare', 'arrest'],
  ['art', 'rate', 'cater', 'racket'],
  ['nut', 'tune', 'tuned', 'turned'],
  ['gee', 'edge', 'ledge', 'legend'],
  ['lad', 'lead', 'laden', 'candle'],
  ['ace', 'each', 'reach', 'search'],
  ['fat', 'flat', 'fault', 'faulty'],
  ['rat', 'rate', 'heart', 'rather'],
  ['set', 'east', 'stale', 'salute'],
  ['her', 'hear', 'heart', 'father'],
  ['pat', 'part', 'strap', 'pastor'],
  ['red', 'dare', 'dared', 'adored'],
  ['sat', 'seat', 'paste', 'staple'],
  ['sea', 'case', 'chase', 'search'],
  ['ace', 'care', 'racer', 'career'],
  ['bet', 'debt', 'debut', 'busted'],
  ['ten', 'tone', 'monte', 'mentor'],
  ['pot', 'plot', 'pilot', 'polite'],
  ['art', 'tear', 'heart', 'father'],
  ['let', 'late', 'delta', 'detail'],
  ['tie', 'tide', 'tried', 'editor'],
  ['ten', 'sent', 'scent', 'nicest'],
  ['low', 'bowl', 'bowel', 'bowled'],
  ['man', 'name', 'meant', 'magnet'],
  ['war', 'ward', 'drawn', 'wander'],
  ['met', 'meat', 'meant', 'inmate'],
  ['ten', 'tend', 'trend', 'tender'],
  ['low', 'bowl', 'elbow', 'bowler'],
  ['man', 'mean', 'named', 'demand'],
  ['tie', 'diet', 'tired', 'credit'],
  ['ray', 'gray', 'angry', 'granny'],
  ['ten', 'neat', 'eaten', 'beaten'],
  ['mad', 'made', 'dream', 'admire'],
  ['sun', 'sung', 'stung', 'strung'],
  ['pit', 'pity', 'tipsy', 'pigsty'],
  ['lad', 'lead', 'laced', 'cradle'],
  ['ain', 'pain', 'panic', 'pacing'],
  ['nor', 'corn', 'recon', 'corner'],
  ['set', 'seat', 'yeast', 'stayed'],
  ['ace', 'came', 'camel', 'marcel'],
  ['air', 'rain', 'train', 'martin'],
  ['lie', 'line', 'alien', 'nailed'],
  ['rat', 'star', 'roast', 'pastor'],
  ['sat', 'east', 'tesla', 'slater'],
  ['low', 'bowl', 'below', 'blower'],
  ['per', 'pure', 'super', 'supper'],
  ['his', 'sigh', 'sight', 'tights'],
  ['map', 'lamp', 'maple', 'palmer'],
  ['sat', 'task', 'stark', 'skater'],
  ['let', 'left', 'fetal', 'falter'],
  ['fit', 'fist', 'first', 'strife'],
  ['sit', 'spit', 'spilt', 'pistol'],
  ['set', 'seat', 'paste', 'staple'],
  ['sat', 'salt', 'stale', 'staple'],
  ['war', 'wear', 'water', 'waiter'],
  ['see', 'else', 'sleep', 'please'],
  ['lie', 'file', 'filet', 'lifted'],
  ['pot', 'port', 'sport', 'presto'],
  ['air', 'pair', 'april', 'spiral'],
  ['bar', 'brad', 'rabid', 'bridal'],
  ['set', 'seat', 'least', 'castle'],
  ['aye', 'year', 'repay', 'player'],
  ['ace', 'case', 'scare', 'search'],
  ['mac', 'calm', 'camel', 'calmed'],
  ['rat', 'rate', 'stare', 'master'],
  ['sat', 'seat', 'haste', 'chaste'],
  ['row', 'wore', 'worse', 'shower'],
  ['but', 'tube', 'debut', 'busted'],
  ['art', 'cart', 'track', 'racket'],
  ['hat', 'what', 'wheat', 'wealth'],
  ['ten', 'nest', 'stone', 'soften'],
  ['act', 'chat', 'teach', 'chaste'],
  ['led', 'deal', 'pedal', 'paddle'],
  ['win', 'wing', 'wring', 'wiring'],
  ['hat', 'chat', 'yacht', 'chatty'],
  ['won', 'worn', 'drown', 'downer'],
  ['sat', 'star', 'smart', 'master'],
  ['led', 'deal', 'dealt', 'talked'],
  ['art', 'rate', 'crate', 'carpet'],
  ['lie', 'mile', 'slime', 'smiled'],
  ['rat', 'tear', 'grate', 'garret'],
  ['sat', 'cast', 'stack', 'casket'],
  ['bar', 'grab', 'barge', 'badger'],
  ['art', 'rate', 'trace', 'create'],
  ['set', 'step', 'spite', 'priest'],
  ['ole', 'mole', 'motel', 'omelet'],
  ['one', 'once', 'recon', 'corner'],
  ['tea', 'date', 'cadet', 'coated'],
  ['sea', 'case', 'cause', 'caused'],
  ['aid', 'dial', 'tidal', 'detail'],
  ['set', 'site', 'stein', 'silent'],
  ['rat', 'star', 'darts', 'stared'],
  ['leo', 'role', 'lover', 'overly'],
  ['row', 'word', 'drown', 'wonder'],
  ['for', 'frog', 'forge', 'forget'],
  ['pal', 'plan', 'plane', 'planet'],
  ['ain', 'pain', 'paint', 'taping'],
  ['sat', 'east', 'steal', 'stella'],
  ['lad', 'lady', 'daily', 'milady'],
  ['ace', 'race', 'cedar', 'sacred'],
  ['bar', 'bear', 'beard', 'barbed'],
  ['lie', 'lied', 'liked', 'licked'],
  ['lie', 'mile', 'email', 'malice'],
  ['pro', 'rope', 'opera', 'parole'],
  ['tie', 'site', 'stein', 'listen'],
  ['ice', 'eric', 'relic', 'circle'],
  ['nor', 'horn', 'rhino', 'heroin'],
  ['red', 'read', 'trade', 'dreamt'],
  ['lap', 'plan', 'plane', 'planet'],
  ['sea', 'east', 'yeast', 'steady'],
  ['ain', 'nail', 'snail', 'signal'],
  ['bet', 'beth', 'berth', 'bother'],
  ['ale', 'male', 'flame', 'female'],
  ['red', 'read', 'beard', 'badger'],
  ['led', 'lead', 'dealt', 'lasted'],
  ['man', 'main', 'manic', 'cinema'],
  ['sat', 'past', 'paste', 'aspect'],
  ['too', 'root', 'robot', 'reboot'],
  ['sea', 'seat', 'asset', 'safest'],
  ['cat', 'chat', 'chant', 'snatch'],
  ['lab', 'bald', 'blade', 'bailed'],
  ['tom', 'most', 'moist', 'sitcom'],
  ['not', 'tone', 'noted', 'stoned'],
  ['ace', 'care', 'cater', 'cartel'],
  ['rat', 'star', 'stark', 'streak'],
  ['owe', 'wore', 'power', 'powder'],
  ['air', 'pair', 'pilar', 'pillar'],
  ['sat', 'seat', 'beast', 'stable'],
  ['red', 'read', 'dread', 'ladder'],
  ['ten', 'sent', 'stern', 'resent'],
  ['sea', 'seal', 'lapse', 'please'],
  ['ole', 'love', 'olive', 'violet'],
  ['tap', 'trap', 'party', 'pastry'],
  ['god', 'gold', 'lodge', 'golden'],
  ['car', 'care', 'clear', 'recall'],
  ['lad', 'deal', 'medal', 'calmed'],
  ['don', 'dong', 'dingo', 'indigo'],
  ['ace', 'care', 'cedar', 'dancer'],
  ['pal', 'pale', 'apple', 'appeal'],
];
